export const calculateInvestTotalByTranType = (tranArr, arrayType, totalArr) => {
    for (let i=0; i<tranArr.length; i++){
        let transaction = tranArr[i];
        let tranYear = "";
        let tranAmt = 0;
        let tranType = "";           
        switch (arrayType){
            case "active":
                tranType = transaction.tranType;
                tranAmt = (+transaction.unitPrice * +transaction.quantity).toFixed(2);
                if (tranType === "buy"){
                    tranAmt = tranAmt * -1;
                }
                tranYear = transaction.transactionDate.split("-")[0];
                break;
            case "history":
                tranType = transaction.tranType;
                tranAmt = +transaction.sellAmount;
                tranYear = transaction.dateClosed.split("-")[0];
                break;
            case "tax":
                tranType = transaction.taxType;
                tranAmt = +transaction.taxAmount;
                tranYear = transaction.datePaid.split("-")[0];
                break;
            default: 
                break;
        }
        let tranIndx = totalArr.findIndex(elem => elem.tranType + elem.tranYear === 
            tranType + tranYear);
        let tranArrObj = {};
        if (tranIndx === -1){
            tranArrObj = {tranYear: tranYear, tranType: tranType,
                tranAmt: +tranAmt};
            totalArr.push(tranArrObj);
        }else{
            totalArr[tranIndx].tranAmt += +tranAmt;
        }
        tranIndx = totalArr.findIndex(elem => elem.tranType + elem.tranYear ===
            tranType + "all");
        if (tranIndx === -1){
            tranArrObj = {tranYear: "all", tranType: tranType, tranAmt: +tranAmt};
            totalArr.push(tranArrObj);
        }else{
            totalArr[tranIndx].tranAmt += +tranAmt;
        }
    }
    return totalArr;
}
export default calculateInvestTotalByTranType;